export default __webpack_public_path__ + "static/media/bg_vestibular.ce9ed7e0.jpeg";